import React, { Fragment } from 'react';
import { Dropdown, Form } from 'semantic-ui-react';
import AllLawyersDropdown from '../../dropdowns/AllLawyersDropdown';
import Field from '../../Field';

const LawyerFormField = ({
  onChange,
  lawyers,
  crmState,
  fluid,
  search,
  countries,
  lawyer,
  litigationCountry,
  displayInline,
}) => {
  const EligibleCountry = (
    <Fragment>
      <label>Eligible Country</label>
      <Field>
        <Dropdown
          fluid={fluid}
          selection={Boolean(countries)}
          options={countries}
          name="litigationCountry"
          placeholder="Eligible Country"
          onChange={onChange}
          value={litigationCountry}
          selectOnBlur={false}
        />
      </Field>
    </Fragment>
  );

  const Lawyer = (
    <Fragment>
      <label>Lawyer</label>
      <AllLawyersDropdown
        selection={Boolean(lawyers)}
        name="lawyer"
        placeholder="Lawyer"
        onChange={onChange}
        value={lawyer}
        disabled={!litigationCountry}
        fluid={fluid}
        search={search}
        options={lawyers}
      />
    </Fragment>
  );
  if (displayInline) {
    return (
      <Form.Group>
        <Field width={4}>{EligibleCountry}</Field>
        <Field width={4}>{Lawyer}</Field>
      </Form.Group>
    );
  }

  return (
    <Form.Group>
      <Field width={4}>
        {EligibleCountry}
        {Lawyer}
      </Field>
    </Form.Group>
  );
};

export default LawyerFormField;



// WEBPACK FOOTER //
// ./src/component/FormFields/LawyerFormField/LawyerFormField.js